export default {"src":"/_next/static/image/public/images/flags/flag_92.e6d7c2e9302e79f1bd27a56f1b9e051e.svg","height":16,"width":24};